function displayCompareBudgetsModal(originBudget = undefined) {
	const budgetSelectTemplate = document.querySelector('.compare-budget-modal_budget-selector')

	if (!budgetSelectTemplate) {
		throw 'Missing budget selector for compare budgets modal';
	}

	// Clone template select
	const budgetSelect = budgetSelectTemplate.cloneNode(true);

	budgetSelect.classList.add('instance');

	// If a budget was passed, disable it on the select
	if (originBudget && originBudget.id) {
		budgetSelect.querySelectorAll('option').forEach(option => {
			if (option.value === originBudget.id.toString()) {
				option.disabled = true;
			}
		})
	}

	const modalContent = `
		${budgetSelect.outerHTML}
	`;

	// Display Swal modal
	return Swal.fire({
		html: modalContent,
		title: 'Select budget to compare with',
		confirmButtonText: 'Compare Budgets',
	}).then(result => {
		if(result.isConfirmed){
			const selector = `
				.compare-budget-modal_budget-selector.instance
				select
			`;
			const targetBudget = document.querySelector(selector).value;

			// noinspection JSUnresolvedVariable
			const compareUrl = window.compareBudgetsModal_compareGetUrl
				.replace('_BUDGET_A_', originBudget.id)
				.replace('_BUDGET_B_', targetBudget);

			window.open(compareUrl, '_blank');
		}
	})
}

export {displayCompareBudgetsModal}
